export const getActiveWarrantCount = (rows) =>
  rows.filter((row) => row.Disposition === 'Active').length;
